import Confirm, { ConfirmPageTop } from '@chegg-wt/core/components/Layouts/Confirm'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import React from 'react'
import { useRouter } from 'next/router'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { getSourceTypeName, sourceTypeById } from '@chegg-wt/core/utils/sourceTypes'
import {
  getCapitalizedSEONameOfStyle,
  isStyleIdInValid,
} from '@chegg-wt/core/utils/styles'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import { NextPageContext } from 'next'
import { getSourceFromQuery } from '../../../utils/routes'
import { confirmContent } from '../../../copy/CMSContent'

const ConfirmPage: NextPageWithLayout = () => {
  const router = useRouter()
  const { style, source: sourceQuery } = router.query as { style: string; source: string }
  const source = getSourceFromQuery(router, sourceQuery)
  const formattedStyle = getCapitalizedSEONameOfStyle(style)

  useOnUnloadTimeOnPage()
  return (
    <>
      <SEOTitle
        title={`Citation Evaluation | ${formattedStyle} | ${getSourceTypeName(
          source
        )} | Citation Machine`}
      />
      <Confirm copy={confirmContent} />
    </>
  )
}

export const getServerSideProps = async ({ query }: NextPageContext) => {
  const { style, source: sourceQuery } = query as { style: string; source: string }
  const source = getSourceFromQuery({ route: '/[style]/[source]/confirm' }, sourceQuery)

  return {
    props: {},
    notFound: isStyleIdInValid(style) || !sourceTypeById(source),
  }
}
ConfirmPage.getPageLayout = (page) => getLvpLayout(page, () => <ConfirmPageTop />)

export default ConfirmPage
